import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";

@Component({
  selector: 'app-prime-famille',
  templateUrl: './prime-famille.component.html',
  styleUrls: ['./prime-famille.component.scss']
})
export class PrimeFamilleComponent implements OnInit {

indiceTab: number = 0;
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  itemToAdd: any = {}
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "beneficiairePrime";
  title: string = 'bénéficiaire prime'
  createMessage = ''
  editMessage = ''
  deleteMessage = ''
  itemsParentFonctionnalites = []

  gender = 'M'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = []
  itemsGenre: any = []
  itemsFiliale: any = []
  searchKey: any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  itemsToSaveBenef: any;
  currentBenef: any;
  @Input() matricule_assure: any;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    let text1 = this.gender == 'M' ? 'un' : 'une'
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title


  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  onGoToNextTab(event) {
    this.indiceTab++
    console.log('event: ', event)
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log('change: ', changes)
    if (changes.matricule_assure.currentValue) {
      console.log('La valeur a changé de', changes.matricule_assure.previousValue, 'à', changes.matricule_assure.currentValue);

      setTimeout(() => {
        // this.itemToSave = changes.matricule_assure.currentValue
        this.matricule_assure = changes.matricule_assure.currentValue
        this.getItems()
      });
    }
  }

  pageChanged(event: any): void {
    this.currentPage = event.page - 1;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }

  openModal(data: any, template: TemplateRef<any>) {

    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-60",
    };
    this.itemToSave = {};
    if (data) {

      this.itemToSave = Object.assign({}, data);
    }

    this.modalRef = this.modalService.show(template, config);
  }






  getItems() {
    if (!this.matricule_assure) {
      return
    }
    if (this.matricule_assure.toString().length < 8) {
      return
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      // order_by:'-created_at',
      data: {
        matricule_assure: this.matricule_assure
      },
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res['hasError']) {
            this.items = res["items"];
            this.items.sort((a, b) => this.customSortBeneficiaires(a, b));

            
            this.totalItems = res["count"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => { }
      );
  }

  customSortBeneficiaires(a, b) {
    const desiredOrder = [
      "A",
      "C",
      "E",
      "ASC",
      "AUT",
    ];
    return (
      desiredOrder.indexOf(a.statut_codification) -
      desiredOrder.indexOf(b.statut_codification)
    );
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

















  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }







  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  load_filiale_data() {
    this.getItems();
  }









  handleImageError(item) {
    item.beneficiaire_image_url = 'assets/images/custom/user-ano.jpeg'
  }

  roundToDecimal(num, decimalPlaces) {
    num = Number(num)
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(num * factor) / factor;
  }


  ngOnInit() {
    this.resetForm();
    this.getItems();
    this.getItemsFiliale();
  }

}
